import { useCallback, useEffect, useMemo, useRef, useState } from 'react';

export default function useImageLoaded() {
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);
  const ref = useRef<HTMLImageElement | null>(null);

  const onLoad = useCallback(() => {
    setLoaded(true);
  }, [setLoaded]);

  const onError = useCallback(() => {
    setError(true);
  }, [setError]);

  useEffect(() => {
    if (ref.current?.complete) {
      onLoad();
    }
  }, [onLoad]);

  return useMemo(
    () => ({ ref, loaded, error, onError, onLoad }),
    [loaded, error, onError, onLoad]
  );
}
